<div class="batch-view">
    <ng-container [dynamic]="view()"></ng-container>
</div>
